import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SpgPage } from './spg.page';

const routes: Routes = [
  {
    path: '',
    component: SpgPage
  },
  {
    path: 'spg-form',
    loadChildren: () => import('./spg-form/spg-form.module').then( m => m.SpgFormPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SpgPageRoutingModule {}
